import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotes: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNotes"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5H20.5V21.5H3.5V17H2.5V15H3.5V13H2.5V11H3.5V9H2.5V7H3.5V2.5ZM9 7H15V9H9V7ZM9 11H13V13H9V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotes;
